import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const SYSRutinMeny: IRutinInfo[] = [
  rutinInfos.rtnUsers,
  rutinInfos.rtnRoller,
  rutinInfos.rtnArbetsstalle,
  rutinInfos.rtnUsersMall,
  rutinInfos.rtnBokfar,
  rutinInfos.rtnKonteringskod,
  rutinInfos.rtnValuta,
  rutinInfos.rtnMoms,
  rutinInfos.rtnBank,
  rutinInfos.rtnSIEMottagningsvag,
  rutinInfos.rtnFakturamottagningsvag,
  rutinInfos.rtnOrdermottagningsvag,
  rutinInfos.rtnUtbetalningsvag,
  rutinInfos.rtnLeveransvillkor,
  rutinInfos.rtnFakturakoder,
  rutinInfos.rtnFakturaformedlare,
  rutinInfos.rtnBetalningssatt,
  rutinInfos.rtnInbetalningsvag,
  rutinInfos.rtnBetalningsvillkor,
  rutinInfos.rtnKravrutin,
  rutinInfos.rtnRanteTabell,
  rutinInfos.rtnAutogiromall,
  rutinInfos.rtnEnhet,
  rutinInfos.rtnFakturalayout,
  rutinInfos.rtnRapportLayout,
  rutinInfos.rtnLand,
  rutinInfos.rtnSprak,
  rutinInfos.rtnTitlar,
  rutinInfos.rtnAdressbokKontakter,
  rutinInfos.rtnJobb,
  rutinInfos.rtnVisaRapporter,
  rutinInfos.rtnDemo1,
  rutinInfos.rtnTest1,
  rutinInfos.rtnTest2,
];

export default SYSRutinMeny;
